import React from "react";
import { useNavigate } from "react-router-dom";
import "./LegalPage.css";
import hiveLogo from "../../assets/logos/hive_logo_normal.webp";
import Footer from "../footer/Footer";

const Privacy = () => {
  const navigate = useNavigate();

  return (
    <div className="legal-page">
      <div className="legal-shell">
        <div className="legal-nav">
          <div className="legal-nav-left">
            <img src={hiveLogo} alt="Hive Team" />
            <h1>Privacy Policy</h1>
          </div>
          <button className="legal-home-btn" onClick={() => navigate("/")}>
            Back to Home
          </button>
        </div>

        <div className="legal-card">
          <h2>Privacy Policy</h2>
          <p>Last updated: 20.01.2026</p>
          <p>
            HiveTeam ("we", "us", "our"), operated by Lupus Development SRL,
            respects your privacy and is committed to protecting personal data
            of users who visit hiveteam.dev or interact with our services. This
            policy explains how we collect, use, store, and protect your
            information in accordance with GDPR (EU Regulation 2016/679).
          </p>
        </div>

        <div className="legal-card">
          <h2>1. Information We Collect</h2>
          <ul>
            <li>
              <strong>Personal Information</strong>: Name, email address,
              Discord username, billing information (when required for
              services), and any information you voluntarily provide via forms
              or direct contact.
            </li>
            <li>
              <strong>Technical & Usage Data</strong>: IP address, browser type
              and version, device information, pages visited and interaction
              data, cookies and similar technologies.
            </li>
          </ul>
        </div>

        <div className="legal-card">
          <h2>2. How We Collect Data</h2>
          <ul>
            <li>You contact us through the website or Discord.</li>
            <li>You request or purchase services.</li>
            <li>You subscribe to updates or offers.</li>
            <li>You browse our website (via cookies & analytics tools).</li>
          </ul>
        </div>

        <div className="legal-card">
          <h2>3. How We Use Your Information</h2>
          <ul>
            <li>Provide and manage our services.</li>
            <li>Communicate with you regarding requests or support.</li>
            <li>Process payments and invoices.</li>
            <li>Improve website performance and user experience.</li>
            <li>Prevent fraud and abuse.</li>
            <li>Comply with legal obligations.</li>
          </ul>
        </div>

        <div className="legal-card">
          <h2>4. Legal Basis for Processing (GDPR)</h2>
          <ul>
            <li>Your consent.</li>
            <li>Performance of a contract.</li>
            <li>Legal obligations.</li>
            <li>
              Legitimate business interests (without overriding your rights).
            </li>
          </ul>
        </div>

        <div className="legal-card">
          <h2>5. Cookies</h2>
          <p>
            HiveTeam uses cookies to analyze traffic and user behavior and to
            improve functionality and performance. You can disable cookies at
            any time through your browser settings.
          </p>
        </div>

        <div className="legal-card">
          <h2>6. Data Sharing & Third Parties</h2>
          <p>
            We do not sell your personal data. Data may be shared only with:
          </p>
          <ul>
            <li>Payment processors (when applicable).</li>
            <li>Hosting & infrastructure providers.</li>
            <li>Legal authorities (only if required by law).</li>
          </ul>
          <p>All third parties comply with GDPR standards.</p>
        </div>

        <div className="legal-card">
          <h2>7. Data Storage & Security</h2>
          <p>
            We take appropriate technical and organizational measures to protect
            your data, including secure servers, restricted access, and
            encrypted communications where applicable. Data is stored only as
            long as necessary for its purpose.
          </p>
        </div>

        <div className="legal-card">
          <h2>8. Your Rights (GDPR)</h2>
          <ul>
            <li>Access your personal data.</li>
            <li>Request correction or deletion.</li>
            <li>Restrict or object to processing.</li>
            <li>Request data portability.</li>
            <li>Withdraw consent at any time.</li>
          </ul>
          <p>
            To exercise these rights, contact us at office@hiveteam.dev or via
            the official HiveTeam Discord server.
          </p>
        </div>

        <div className="legal-card">
          <h2>9. Data Retention</h2>
          <p>
            We retain personal data only for the duration of the business
            relationship and for legal/accounting requirements. After this
            period, data is securely deleted.
          </p>
        </div>

        <div className="legal-card">
          <h2>10. Children’s Privacy</h2>
          <p>
            HiveTeam services are not intended for children under 16, and we do
            not knowingly collect data from minors.
          </p>
        </div>

        <div className="legal-card">
          <h2>11. Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. Any changes
            will be posted on this page with an updated revision date.
          </p>
        </div>

        <div className="legal-card">
          <h2>12. Contact Information</h2>
          <p>Company: Lupus Development SRL | Brand: HiveTeam</p>
          <p>Website: https://hiveteam.dev</p>
          <p>Email: office@hiveteam.dev</p>
          <p>Primary Communication: Discord (official HiveTeam server)</p>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Privacy;
